/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_3_HInputs */

const en_privacy_3_h = /** @type {(inputs: Privacy_3_HInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI processing`)
};

const id_privacy_3_h = /** @type {(inputs: Privacy_3_HInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pemrosesan AI`)
};

/**
* | output |
* | --- |
* | "AI processing" |
*
* @param {Privacy_3_HInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const privacy_3_h = /** @type {((inputs?: Privacy_3_HInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_3_HInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_privacy_3_h(inputs)
	return en_privacy_3_h(inputs)
});